module.exports = __webpack_public_path__ + "static/media/Professional-Qualification-in-Marine-Surveying-Course-Handbook.7cbacff4.pdf";